export default "__VITE_ASSET___q3hjocJ__"